<template>
  <div class="highlights-card">
    <div class="highlights-header" @click="toggleCollapse">
      <span class="sparkle-icon">✨</span>
      <span class="highlights-title">Generate Key Highlights</span>
      <span class="chevron" :class="{ collapsed: isCollapsed }">&#x25B2;</span>
    </div>
    <div class="collapse" :class="{ show: !isCollapsed }">
      <div class="highlights-body">
        <div v-if="loading" class="loader-container">
          <div class="loader"></div>
        </div>
        <ul v-else class="highlights-list">
          <li v-for="highlight in highlights" :key="highlight"><b>{{ highlight }}</b></li>
        </ul>
        <div class="divider"></div>
        <div class="mistake-text">
          See a mistake? <a href="#" class="mistake-link">Let us know.</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyHighlights',
  props: {
    highlights: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: true
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
</script>

<style>
.highlights-card {
  border: 2px solid #a259d9;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  padding: 0;
  background: #fff;
}

.highlights-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 1.1rem 1.2rem 0.7rem 1.2rem;
  cursor: pointer;
  position: relative;
}

.sparkle-icon {
  font-size: 1.3rem;
  color: #a259d9;
  margin-right: 0.3rem;
}

.highlights-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #222;
  margin-right: auto;
}

.chevron {
  font-size: 1.2rem;
  color: #222;
  margin-left: 0.5rem;
  transition: transform 0.2s;
  user-select: none;
}
.chevron.collapsed {
  transform: rotate(180deg);
}

.collapse {
  display: none;
}
.collapse.show {
  display: block;
}

.highlights-body {
  padding: 0 1.2rem 1.2rem 1.2rem;
}

.highlights-list {
  list-style-type: disc;
  padding-left: 3.5rem;
  margin-top: 0.7rem;
  margin-bottom: 0.7rem;
}

.highlights-list li {
  margin-bottom: 0.5rem;
  color: #222;
  font-size: 1rem;
  line-height: 1.6;
}

.divider {
  border-top: 1px solid #e9ecef;
  margin: 1.1rem 0 0.7rem 0;
}

.mistake-text {
  color: #222;
  font-size: 1rem;
  margin-top: 0;
}

.mistake-link {
  color: #222;
  font-weight: bold;
  text-decoration: none;
  margin-left: 0.2rem;
}
.mistake-link:hover {
  text-decoration: underline;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #a259d9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 
